<template>

    <form ref="colaboradorlogacesso-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
					<div class="form-group col-md-12">
                        <label for="colaboradorId">ColaboradorId</label>
                        <input type="text" class="form-control" name="colaboradorId" placeholder="ColaboradorId" v-model="model.colaboradorId" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="escolaId">EscolaId</label>
                        <input type="text" class="form-control" name="escolaId" placeholder="EscolaId" v-model="model.escolaId" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="email">Email</label>
                        <input type="text" class="form-control" name="email" placeholder="Email" v-model="model.email" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataLogin">DataLogin</label>
                        <input type="text" v-datepicker class="form-control" name="dataLogin" v-model="model.dataLogin" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataLogoff">DataLogoff</label>
                        <input type="text" v-datepicker class="form-control" name="dataLogoff" v-model="model.dataLogoff"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="ipAcesso">IpAcesso</label>
                        <input type="text" class="form-control" name="ipAcesso" placeholder="IpAcesso" v-model="model.ipAcesso"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="localizacao">Localizacao</label>
                        <input type="text" class="form-control" name="localizacao" placeholder="Localizacao" v-model="model.localizacao"  />
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "colaboradorlogacesso-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "colaboradorlogacesso-form-create",
            
            resources: {
                create: 'colaboradorlogacesso',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

